export const QUERY_STALE_TIME = {
  detail: 30 * 1000,
  sseStatus: Infinity,
  groupsList: 60 * 1000,
  preCheck: 30 * 1000,
} as const;

export const QUERY_GC_TIME = {
  detail: 10 * 60 * 1000,
  sseStatus: Infinity,
  groupsList: 10 * 60 * 1000,
  preCheck: 10 * 60 * 1000,
} as const;

export const remoteControlKeys = {
  all: ['bi-directional'] as const,
  detailsOf: (equipmentId: string) => [...remoteControlKeys.all, equipmentId] as const,
  detail: (equipmentId: string, plantId: string | null) =>
    plantId === null ? remoteControlKeys.detailsOf(equipmentId) : ([...remoteControlKeys.detailsOf(equipmentId), plantId] as const),
  sseStatus: (serialNumber: string) => ['remote-control', 'sse-status', serialNumber] as const,
  groupsList: (assetId: string) => [...remoteControlKeys.all, 'groups-list', assetId] as const,
  preCheckAll: () => [...remoteControlKeys.all, 'pre-check'] as const,
  preChecksOf: (equipmentId: string) => [...remoteControlKeys.preCheckAll(), equipmentId] as const,
  preCheck: (equipmentId: string, plantId: string | null) =>
    plantId === null ? remoteControlKeys.preChecksOf(equipmentId) : ([...remoteControlKeys.preChecksOf(equipmentId), plantId] as const),
};

export const remoteControlMutationKeys = {
  equipmentAction: (equipmentId: string) =>
    [...remoteControlKeys.all, 'equipment-action', equipmentId] as const,
  groupAction: (equipmentId: string) =>
    [...remoteControlKeys.all, 'group-action', equipmentId] as const,
};
